import React, {useEffect} from "react";
import {
  Table,
  DataTable,
  Button,
  Input,
  Icon
} from "@arnsbogroup/react-voicearchive";
import useApi from 'hooks/useApi';
import {
  FileMeta,
  FilePreview,
} from 'components/datatable'

export default ({ task }) => {
  const [sentences, setSentences] = React.useState([]);
  const [sentence, setSentence] = React.useState("");

  const [aiVoiceLines, loading,, refetch] = useApi(`/rest/v2/task/${task.uid}/ai-voice-lines`, { load: false })
  useEffect(() => {
    reloadVoiceLines();
  }, [task?.uid, task?.tstamp])

  useEffect(() => {
    if (aiVoiceLines) {
      setSentences(aiVoiceLines);
    }
  }, [aiVoiceLines])

  function reloadVoiceLines() {
    if (!!task?.uid) {
      refetch(`/rest/v2/task/${task.uid}/ai-voice-lines`)
    }
  }

  function addSentenceHandler() {
    if (sentence) {
      setSentence("");

      fetch(`/rest/v2/aivoiceline`,{
        method: 'POST',
        body: JSON.stringify({
          line: sentence,
          ordertask_uid: task.uid,
        }),
      })
        .then(() => {
          reloadVoiceLines();
        })
        .catch((error) => toastr.error(error))
    }
  }

  function deleteHandler(uid) {
    fetch(`/rest/v2/aivoiceline`,{
      method: 'DELETE',
      body: JSON.stringify({ uid: uid }),
    })
      .then(() => {
        reloadVoiceLines();
      })
      .catch((error) => toastr.error(error))
  }

  return (
    <div className="p-4">
      <div className="grid lg:grid-cols-2 sm:grid-cols-2 gap-4 my-4">
        <div>
          <Input
            labelClassName="text-xs"
            placeholder="Voice Line"
            value={sentence}
            onChange={({ target: { value } }) => {
              setSentence(value);
            }}
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                addSentenceHandler();
              }
            }}
          />
        </div>

        <div className="my-auto flex space-x-2">
          <Button
            size="sm"
            variant={'outline'}
            onClick={addSentenceHandler}
          >
            Add Line
          </Button>       
        </div>
      </div>
      <DataTable
        noDataMessage="No voice lines"
        components={{
          Tr: ({ childProps = {}, ...innerProps }) => {
            return (
              <Table.Tr 
                title={(+childProps.deleted || +childProps.hidden) ?
                  'This line has been deleted' :
                  ''}
                className={(+childProps.deleted || +childProps.hidden) ?
                  'bg-gray-200' : ''}
                {...innerProps }
              />
            )
          }
        }}
        indicators={[
          (voiceLine) => (
            <Icon
              onClick={() => {
                  if (!(+voiceLine.deleted || +voiceLine.hidden)
                    && confirm(`Are you sure you want to delete this line?`))
                  {
                    deleteHandler(voiceLine.uid);
                  }
                }
              }
              className={(+voiceLine.deleted || +voiceLine.hidden)
                ? "text-gray-400 cursor-not-allowed"
                : "text-negative cursor-pointer"}
              icon={['fal', 'trash']}
            />
          ),
        ]}
        head={{
          line: { label: "Voice Line" },
          cdn_url: { className: 'w-2/12', label: 'Preview' },
          duration: { className: 'w-2/12', label: 'Meta' }
        }}
        body={{
          line: (props) => <div className={`whitespace-normal ${(+props.deleted || +props.hidden) ? 'line-through' : ''}`}><p>{props.children}</p></div>,
          cdn_url: ({file}) =>  file.uid ? <FilePreview {...file} /> : null,
          duration: ({file}) => file.uid ? <FileMeta {...file} className="truncate" /> : null,
        }}
        entries={sentences}
      />
    </div>
  );
};
